import React, { useEffect } from 'react';
import { CButton, CForm, CModal, CModalBody, CModalFooter, CModalHeader } from '@coreui/react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { connect, DispatchProp } from 'react-redux';
import LoadingButton from '../../../shared/components/LoadingButton';
import { ResetUpdateUserState, ResetUserPassword } from '../../actions/userManagement.action';
import { UserPasswordPayload, UserInfo } from '../../../shared/models/user';
import { RootState } from '../../../store/state';
import ResetPasswordForm from '../../components/ResetPasswordForm';

const validationSchema = Yup.object({
  password: Yup.string().matches(/^(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/, 'Must contain 8 characters, at least 1 uppercase, 1 number').required("This field is required"),
  // eslint-disable-next-line func-names
  passwordConfirm: Yup.string().test('passwords-match', 'Passwords must match', function(value) {
    return this.parent.password === value;
  }).required("This field is required"),
});

export interface ResetPasswordModalProps extends DispatchProp {
  technician: UserInfo;
  show: boolean;
  close: () => void;
  saving: boolean;
  saved: boolean;
}

const ResetPasswordModal = (props: ResetPasswordModalProps) => {
  const { technician, show, close, saving, saved, dispatch } = props;

  const onSubmit = (values: UserPasswordPayload) => {
    dispatch(new ResetUserPassword({ userId: technician.id, body: values }));
  };

  const formik = useFormik({
      initialValues: {
        password: '',
        passwordConfirm: '',
      } as UserPasswordPayload,
      validationSchema,
      onSubmit,
    },
  );

  const handleClose = () => {
    close();
    formik.resetForm();
  };

  useEffect(() => {
    if (saved) {
      dispatch(new ResetUpdateUserState());
      handleClose();
    }
  }, [saved]);

  return (
    show && <CModal className="mt-5 pt-5" id="reset-password-modal" show={ show } onClose={ handleClose } closeOnBackdrop={ false }>
      <CModalHeader closeButton>Reset Password</CModalHeader>
      <CForm onSubmit={ formik.handleSubmit }>
        <CModalBody>
          <ResetPasswordForm formik={ formik } />
        </CModalBody>
        <CModalFooter>
          <div className="glympse-btnWrapper">
            <LoadingButton color='primary' className='bg-color-orange border-0 roundedBtn pl-5 pr-5 glympser-container--roundedWithShadow' type='submit' isLoading={ saving }>Save</LoadingButton>
          </div>
          <div className="glympse-btnWrapper">
            <CButton className="glympse-cancelBtn" color="light" shape="rounded-pill" variant="ghost" onClick={ handleClose }>Cancel</CButton>
          </div>
        </CModalFooter>
      </CForm>
    </CModal>
  );
};

const mapStateToProps = (state: RootState) => ({
  saving: state?.userManagement?.updateUser?.saving,
  saved: state?.userManagement?.updateUser?.saved,
});

export default connect(mapStateToProps)(ResetPasswordModal);
